<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div class="table-agile-info">
            <el-tabs
              v-model="activeName"
              class="tab-card-label">
              <el-tab-pane label="基础信息">
                <div class="basic-second-title"><i/><em>学生基础信息</em></div>
                <div class="info-manag-wrap">
                  <el-row>
                    <el-col :span="6">
                      <label>姓名:</label>
                      <span>{{ formInfo.custom_name }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>入学时间:</label>
                      <span>{{ formInfo.custom_year }}年{{ formInfo.custom_month }}月</span>
                    </el-col>
                    <el-col :span="6">
                      <label>生日:</label>
                      <span>{{ formInfo.custom_birthday }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>性别:</label>
                      <jm-dict-select
                        v-model="formInfo.custom_sex"
                        text-class="qcrb-blue-span"
                        :show="true"
                        type="dataset"
                        dict-type="student"
                        name="gender"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <label>最后所读学校:</label>
                      <jm-dict-select
                        v-model="formInfo.custom_school_type"
                        text-class="qcrb-blue-span"
                        :show="true"
                        type="dataset"
                        dict-type="student"
                        name="schoolType"/>
                      <span>{{ formInfo.custom_school }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>最后所读专业:</label>
                      <span>{{ formInfo.custom_major }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>户籍地:</label>
                      <jm-areaselect
                        :show="true"
                        v-model="domicile"/>
                    </el-col>
                    <el-col :span="6">
                      <label>是否在日:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        type="dataset"
                        dict-type="qcrb"
                        v-model="formInfo.custom_injapan"
                        name="handleYesNo"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <label>最高学历:</label>
                      <jm-dict-select
                        v-model="formInfo.custom_education"
                        text-class="qcrb-blue-span"
                        :show="true"
                        dict-type="education"/>
                    </el-col>
                    <el-col :span="6">
                      <label>学生毕业时间:</label>
                      <span>{{ formInfo.custom_over }}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="basic-second-title"><i/><em>均分及语言成绩</em></div>
                <div class="info-manag-wrap">
                  <el-row>
                    <el-col :span="6">
                      <label>GPA:</label>
                      <span>{{ formInfo.custom_avg_score }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>JLPT:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        v-model="scoresForm['JLPT']['ln_level']"
                        dict-type="examjp_d"
                        :filter="item => item.p_value === 'JLPT'"/>
                      <span>{{ scoresForm['JLPT']['ln_all'] }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>J-TEST:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        v-model="scoresForm['J-TEST']['ln_level']"
                        dict-type="examjp_d"
                        :filter="item => item.p_value === 'J-TEST'"/>
                      <span>{{ scoresForm['J-TEST']['ln_all'] }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>BJT:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        v-model="scoresForm['BJT']['ln_level']"
                        dict-type="examjp_d"
                        :filter="item => item.p_value === 'BJT'"/>
                      <span>{{ scoresForm['BJT']['ln_all'] }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <label>NAT:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        v-model="scoresForm['NAT']['ln_level']"
                        dict-type="examjp_d"
                        :filter="item => item.p_value === 'NAT'"/>
                      <span>{{ scoresForm['NAT']['ln_all'] }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>TOEFL:</label>
                      <span>{{ scoresForm['TOEFL']['ln_all'] }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>TOEIC:</label>
                      <span>{{ scoresForm['TOEIC']['ln_all'] }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>IELTS:</label>
                      <span>{{ scoresForm['IELTS']['ln_all'] }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <label>CET:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        v-model="scoresForm['CET']['ln_level']"
                        dict-type="examjp_d"
                        :filter="item => item.p_value === 'CET'"/>
                      <span>{{ scoresForm['CET']['ln_all'] }}</span>
                    </el-col>
                    <el-col :span="6">
                      <label>语言成绩刷新类型:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        :dict-type="['exam', 'examjp']"
                        v-model="formInfo.lang_score1_type"/>&emsp;
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        :dict-type="['exam', 'examjp']"
                        v-model="formInfo.lang_score2_type"/>
                    </el-col>
                    <el-col :span="6">
                      <label>语言成绩刷新时间:</label>
                      <span>{{ formInfo.lang_score1_date }}</span>&emsp;
                      <span>{{ formInfo.lang_score2_date }}</span>
                    </el-col>
                  </el-row>
                </div>
                <div class="basic-second-title"><i/><em>办理信息</em></div>
                <div class="info-manag-wrap">
                  <el-row>
                    <el-col :span="6">
                      <label>申请项目:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        v-model="formHandle.baseinfo.course_id"
                        dict-type="course"
                        :filter="item => item.pid === 485"/>
                    </el-col>
                    <el-col :span="6">
                      <label>办理状态:</label>
                      <jm-dict-select
                        text-class="qcrb-blue-span"
                        :show="true"
                        type="dataset"
                        dict-type="qcrb"
                        v-model="formHandle.baseinfo.status"
                        name="handleStateAdd"/>
                    </el-col>
                  </el-row>

                  <el-row v-if="formHandle.payment.entry.length">
                    <el-col :span="2">
                      <label>APP 订单:</label>
                    </el-col>
                    <el-col :span="22">
                      <el-table :data="formHandle.payment.entry" style="width: 100%" size="mini">
                        <el-table-column prop="srv_name" label="产品名称"/>
                        <el-table-column prop="srv_group" label="产品类型"/>
                        <el-table-column prop="srv_amount" label="合同金额"/>
                        <el-table-column prop="total_amount" label="服务费"/>
                        <el-table-column prop="bargain_amount" label="服务费定金"/>
                        <el-table-column prop="first_amount" label="服务费首款"/>
                        <el-table-column prop="last_amount" label="服务费尾款"/>
                      </el-table>
                    </el-col>
                  </el-row>

                  <el-row v-if="formHandle.payment.fmis.length">
                    <el-col :span="2">
                      <label>前程订单:</label>
                    </el-col>
                    <el-col :span="22">
                      <el-table :data="formHandle.payment.fmis" style="width: 100%" size="mini">
                        <el-table-column prop="order_title" label="订单名称"/>
                        <el-table-column prop="need_fee" label="应付总额"/>
                        <el-table-column prop="service_fee" label="服务金额"/>
                        <el-table-column prop="deposit_fee" label="押金"/>
                        <el-table-column prop="paid_fee" label="已付金额"/>
                        <el-table-column prop="last_payment_date" label="最后付款日" />
                      </el-table>
                    </el-col>
                  </el-row>

                  <!-- 未发先订单信息 -->
                  <el-row v-if="!(formHandle.payment.entry.length || formHandle.payment.fmis.length)">
                    <el-col :span="2">
                      <label>订单数据:</label>
                    </el-col>
                    <el-col :span="22">
                      <el-alert type="error" title="暂无有效的订单/报账数据，请联系老师添加" :closable="false"></el-alert>
                    </el-col>
                  </el-row>

                </div>
                <div class="basic-second-title"><i/><em>签约确认表</em></div>
                <div class="info-manag-wrap">
                  <el-row>
                    <el-col :span="24">
                      <quill-editor
                        v-model="formHandle.baseinfo.confirm_form"
                        :options="editorOption"/>
                    </el-col>
                  </el-row>
                </div>
                <!--                <div class="basic-second-title"><i/><em>教授列表</em></div>-->
                <!--                <div class="info-manag-wrap info-sales">-->
                <!--                  <el-row>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>教授列表是否发送:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.is_prof_list"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>教授列表是否反馈:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.is_prof_feedback"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                    <el-col-->
                <!--                      v-if="masterDate.length && masterDate[0].file_list[0]"-->
                <!--                      :span="8">-->
                <!--                      <label>教授列表:</label>-->
                <!--                      <a-->
                <!--                        class="qcrb-blue-span"-->
                <!--                        target="_blank"-->
                <!--                        :href="masterDate[0].file_list[0]">教授列表.rar</a>-->
                <!--                    </el-col>-->
                <!--                  </el-row>-->
                <!--                  <el-row>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>自荐信是否完成:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.is_letter_complete"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>第一封邮件是否发送:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.is_letter_send"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>申请邮箱:</label>-->
                <!--                      <span>{{ formProlist.baseinfo.mail_addr }}</span>-->
                <!--                    </el-col>-->
                <!--                  </el-row>-->
                <!--                </div>-->
                <!--                <div class="basic-second-title"><i/><em>二次销售</em></div>-->
                <!--                <div class="info-manag-wrap info-sales">-->
                <!--                  <el-row>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>是否在我公司办理签证:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.is_resale_visa"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>签证是否下达:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.visa_status"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                  </el-row>-->
                <!--                  <el-row>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>手机是否在我公司办理:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.is_resale_phone"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="8">-->
                <!--                      <label>房屋是否在我公司办理:</label>-->
                <!--                      <jm-dict-select-->
                <!--                        text-class="qcrb-blue-span"-->
                <!--                        :show="true"-->
                <!--                        type="dataset"-->
                <!--                        dict-type="qcrb"-->
                <!--                        v-model="formProlist.baseinfo.is_resale_house"-->
                <!--                        name="handleYesNo"/>-->
                <!--                    </el-col>-->
                <!--                  </el-row>-->
                <!--                </div>-->
              </el-tab-pane>
              <el-tab-pane label="流程信息">
                <div
                  v-if="giveupHidden"
                  class="info-manage-process">
                  <div class="basic-second-title"><i/>在留 <span style="font-weight: bold; color: #f00">【{{ formGiveup.sh_name }} - {{ formGiveup.org_name }}】（放弃）</span></div>
                  <div class="info-process-content">
                    <el-row>
                      <el-col :span="8">
                        <label>在留截止日期:</label>
                        <span>{{ formGiveup.zailiu_deadline }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>通知准备在留材料:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formGiveup.is_zailiu_notified"
                          name="handleNotice"/>
                        <span class="time-default">{{ formGiveup.is_zailiu_notified_time }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>在留材料邮寄:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formGiveup.is_zailiu_posted"
                          name="handlePosted"/>
                        <span class="time-default">{{ formGiveup.is_zailiu_posted_time }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <label>在留材料签收:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formGiveup.is_zailiu_received"
                          name="handleReceived"/>
                        <span class="time-default">{{ formGiveup.is_zailiu_received_time }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>在留下达:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formGiveup.zailiu_status"
                          name="handleStatus"/>
                        <span class="time-default">{{ formGiveup.zailiu_status_time }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>有无宿舍:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formGiveup.is_dormitory"
                          name="handleYesNo"/>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <label>宿舍申请是否成功:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formGiveup.is_dormitory_apply"
                          name="handleYesNo"/>
                      </el-col>
                      <el-col :span="8">
                        <label>宿舍选拔时间:</label>
                        <span>{{ formGiveup.dormitory_date }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>邮箱材料是否交接:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formGiveup.is_mail_exchange"
                          name="handleYesNo"/>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div
                  v-if="successHidden"
                  class="info-manage-process">
                  <div class="basic-second-title"><i/>在留 <span style="font-weight: bold; color: #f00">【{{ formSuccess.sh_name }} - {{ formSuccess.org_name }}】（<jm-dict-select
                    :show="true"
                    type="dataset"
                    dict-type="qcrb"
                    v-model="formSuccess.zailiu_status"
                    name="handleStatus2"/>）</span></div>
                  <div class="info-process-content">
                    <el-row>
                      <el-col :span="8">
                        <label>在留截止日期:</label>
                        <span>{{ formSuccess.zailiu_deadline }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>通知准备在留材料:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formSuccess.is_zailiu_notified"
                          name="handleNotice"/>
                        <span class="time-default">{{ formSuccess.is_zailiu_notified_time }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>在留材料邮寄:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formSuccess.is_zailiu_posted"
                          name="handlePosted"/>
                        <span class="time-default">{{ formSuccess.is_zailiu_posted_time }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <label>在留材料签收:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formSuccess.is_zailiu_received"
                          name="handleReceived"/>
                        <span class="time-default">{{ formSuccess.is_zailiu_received_time }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>在留下达:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formSuccess.zailiu_status"
                          name="handleStatus"/>
                        <span class="time-default">{{ formSuccess.zailiu_status_time }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>有无宿舍:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formSuccess.is_dormitory"
                          name="handleYesNo"/>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <label>宿舍申请是否成功:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formSuccess.is_dormitory_apply"
                          name="handleYesNo"/>
                      </el-col>
                      <el-col :span="8">
                        <label>宿舍选拔时间:</label>
                        <span>{{ formSuccess.dormitory_date }}</span>
                      </el-col>
                      <el-col :span="8">
                        <label>邮箱材料是否交接:</label>
                        <jm-dict-select
                          text-class="qcrb-blue-span"
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="formSuccess.is_mail_exchange"
                          name="handleYesNo"/>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <el-collapse accordion>
                  <el-collapse-item
                    v-for="(item, index) in formProlist.schoolList"
                    :key="item.id"
                    :name="index">
                    <template slot="title">
                      <span>流程{{ index+1 }}：{{ item.sh_name }}&nbsp;-&nbsp;
                        {{ item.org_name }}&nbsp;
                        <jm-dict-select
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="item.status"
                          name="serviceStatus"/>&nbsp;
                        <jm-dict-select
                          :show="true"
                          type="dataset"
                          dict-type="qcrb"
                          v-model="item.stage"
                          name="applyStatus"/></span>
                      <i class="info-title-time">预计出愿时间：{{ item.expect_date }}</i>
                    </template>
                    <div class="info-manage-process">
                      <div class="info-process-content">
                        <el-row>
                          <el-col :span="8">
                            <label>确定办理时间:</label>
                            <span>{{ item.confirm_date }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>申请方式:</label>
                            <span>{{ item.apply_type|filterApplyType }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>同时出院生:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.same_as_leaving"
                              name="handleYesNo"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <label>考试方式:</label>
                            <span>{{ item.exam_type|filterExamType }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>入试信息:</label>
                            <el-input
                              class="jm-input220"
                              readonly
                              v-model="item.exam_link"/>
                          </el-col>
                          <el-col :span="8">
                            <label>出愿要项链接:</label>
                            <el-input
                              class="jm-input220"
                              readonly
                              v-model="item.memo_link"/>
                          </el-col>
                        </el-row>
                      </div>
                      <div
                        v-for="(items, sindex) in item.professorList"
                        :key="sindex"
                        class="info-process-content info-content-angle">
                        <div class="info-angle"><em>{{ items.prof_name }}</em></div>
                        <el-row>
                          <el-col :span="8">
                            <label>意向教授:</label>
                            <span>{{ items.prof_name }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>出现意向的时间:</label>
                            <span>{{ items.intention_date }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>备注:</label>
                            <span>{{ items.remark }}</span>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <label>教授方向:</label>
                            <span>{{ items.research }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>教授职务:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="items.job_duty"
                              name="jobDuty"/>
                          </el-col>
                          <el-col :span="8">
                            <label>约见教授:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="items.is_meet"
                              name="handleYesNo"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <label>跟进状态:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="items.status"
                              name="handleState"/>
                          </el-col>
                          <el-col :span="8">
                            <label>邮箱整理完毕:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="items.is_mail_clean"
                              name="handleYesNo"/>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div class="info-manage-process">
                      <div class="basic-second-title"><i/>出愿</div>
                      <div class="info-process-content">
                        <el-row>
                          <el-col :span="8">
                            <label>出愿截止日期:</label>
                            <span>{{ item.apply_deadline }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>通知准备出愿材料:</label>
                            <jm-dict-select
                              class="jm-input135"
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.is_apply_notified"
                              name="handleNotice"/>
                            <span class="time-default">{{ item.is_apply_notified_time }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>出愿材料邮寄:</label>
                            <jm-dict-select
                              class="jm-input135"
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.is_apply_posted"
                              name="handlePosted"/>
                            <span class="time-default">{{ item.is_apply_posted_time }}</span>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <label>出愿材料签收:</label>
                            <jm-dict-select
                              class="jm-input135"
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.is_apply_received"
                              name="handleReceived"/>
                            <span class="time-default">{{ item.is_apply_received_time }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>入学许可下达:</label>
                            <jm-dict-select
                              class="jm-input135"
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.apply_status"
                              name="handleStatus"/>
                            <span class="time-default">{{ item.apply_status_time }}</span>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div
                      v-if="checkingHidden(index)"
                      class="info-manage-process">
                      <div class="basic-second-title"><i/>事前审查</div>
                      <div class="info-process-content">
                        <el-row>
                          <el-col :span="8">
                            <label>事前审查截止日期:</label>
                            <span>{{ item.checking_deadline }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>通知准备事前审查材料:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.is_checking_notified"
                              name="handleNotice"/>
                          </el-col>
                          <el-col :span="8">
                            <label>事前审查材料是否通过:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.checking_status"
                              name="handleCheckPost"/>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div
                      v-if="item.same_as_leaving === 1"
                      class="info-manage-process">
                      <div class="basic-second-title"><i/>院生出愿</div>
                      <div class="info-process-content">
                        <el-row>
                          <el-col :span="8">
                            <label>出院截止日期:</label>
                            <span>{{ item.leaving_deadline }}</span>
                          </el-col>
                          <el-col :span="8">
                            <label>通知准备出院材料:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.is_leaving_notified"
                              name="handleNotice"/>
                          </el-col>
                          <el-col :span="8">
                            <label>出院材料邮寄:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.is_leaving_posted"
                              name="handlePosted"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <label>出院材料签收:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.is_leaving_received"
                              name="handleReceived"/>
                          </el-col>
                          <el-col :span="8">
                            <label>入学许可下达:</label>
                            <jm-dict-select
                              text-class="qcrb-blue-span"
                              :show="true"
                              type="dataset"
                              dict-type="qcrb"
                              v-model="item.leaving_status"
                              name="handleStatus"/>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import { jmDictSelect, jmAreaselect } from '@/components/tool';
import * as UserApi from '@/api/user.js';
import qcrbPublic from './qcrbPublic.js';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  data() {
    return {
      crmId: null,
      activeName: '',
      formInfo: {},
      scoresForm: {
        BJT: {
          ln_type: 91,
        },
        JLPT: {
          ln_type: 89,
        },
        'J-TEST': {
          ln_type: 90,
        },
        NAT: {
          ln_type: 92,
        },
        TOEFL: {
          ln_type: 23,
        },
        CET: {
          ln_type: 671,
        },
        TOEIC: {
          ln_type: 129,
        },
        IELTS: {
          ln_type: 22,
        },
      },
      formHandle: {
        baseinfo: [],
        payment: {
          entry: [],
          fmis: []
        }
      },
      formProlist: {
        baseinfo: [],
        schoolList: [{
          professorList: [],
        }],
      },
      formGiveup: {},
      formSuccess: {},
      applyType: [],
      examType: [],
      giveupHidden: false,
      successHidden: false,
      domicile: [],
      masterDate: {
        file_list: []
      },
      editorOption: {
        modules: {
          toolbar: null,
        },
        readOnly: true
      },
    };
  },
  created() {
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    jmDictSelect,
    jmAreaselect,
    quillEditor
  },
  methods: {
    /**
     * 学生基础信息
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getStudent() {
      if (!this.crmId) {
        return false;
      }
      UserApi.getBaseInfo(this.crmId).then(({ data }) => {
        this.formInfo = data;
        this.formInfo.custom_over = this.formatDate(this.formInfo.custom_over);
        this.domicile = [data.custom_place_area, data.custom_place_city];
      });
    },
    formatDate(strTime) {
      if (strTime) {
        let date = new Date(strTime);
        return `${date.getFullYear()}年${(date.getMonth() + 1)}月`;
      }
    },
    /**
     * 成绩信息
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    getScores() {
      if (!this.crmId) { // 添加资源
        return true;
      }
      UserApi.getScores(this.crmId).then(({ data }) => {
        this.scoresForm = Object.assign(this.scoresForm, data);
      });
    },
    /**
     * 办理信息
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getPayment() {
      if (!this.crmId) {
        return false;
      }
      this.$http._get({
        url: `/index/qc_process/getProcess/crmid/${this.crmId}`
      }).then(({ data }) => {
        console.info(data);
        this.formHandle = data;
      });
    },
    /**
     * 在留放弃信息
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getGiveup() {
      if (!this.crmId) {
        return false;
      }
      this.$http._get({
        url: `/index/qc_process/getSchoolList/?crmid=${this.crmId}&type=all`
      }).then((data) => {
        data.data.zailiuList.forEach((item) => {
          if (item.current === 0) {
            this.formGiveup = item;
            if (this.formGiveup.zailiu_deadline[0] === this.formGiveup.zailiu_deadline[1]) {
              this.formGiveup.zailiu_deadline = this.formGiveup.zailiu_deadline[0];
            } else {
              this.formGiveup.zailiu_deadline = `${this.formGiveup.zailiu_deadline[0]} ~ ${this.formGiveup.zailiu_deadline[1]}`;
            }
            this.giveupHidden = true;
          } else if (item.current === 1) {
            this.formSuccess = item;
            if (this.formSuccess.zailiu_deadline[0] === this.formSuccess.zailiu_deadline[1]) {
              this.formSuccess.zailiu_deadline = this.formSuccess.zailiu_deadline[0];
            } else {
              this.formSuccess.zailiu_deadline = `${this.formSuccess.zailiu_deadline[0]} ~ ${this.formSuccess.zailiu_deadline[1]}`;
            }
            this.successHidden = true;
          }
        });
      });
    },
    /**
     * 获取用户所有申请数据
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getProcess() {
      if (!this.crmId) {
        return false;
      }
      this.$http._get({
        url: `/index/qc_process/getSchoolList/?crmid=${this.crmId}`
      }).then(({ data }) => {
        this.formProlist = data;
        this.formProlist.schoolList.forEach((school, index) => {
          this.examType[index] = school.exam_type.split(',').map((item) => { return item - 0; });
          this.applyType[index] = school.apply_type.split(',').map((item) => { return item - 0; });
          if (school.apply_deadline[0] === school.apply_deadline[1]) {
            school.apply_deadline = school.apply_deadline[0];
          } else {
            school.apply_deadline = `${school.apply_deadline[0]} ~ ${school.apply_deadline[1]}`;
          }
        });
        this.masterRequest();
      });
    },
    /**
     * 事前审查部分显隐
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    checkingHidden(index) {
      if (this.formProlist.schoolList[index].apply_type) {
        if (this.formProlist.schoolList[index].apply_type.includes('7')) {
          return true;
        }
      }
    },
    /**
     * 教授列表请求
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    masterRequest() {
      if (!this.crmId) {
        return false;
      }
      this.$http._get({
        url: '/index/apply_file/index',
        data: {
          country_id: 485, crm_id: this.crmId, offer_id: this.formProlist.offer_id, offer_school_id: 0, upload_position: '教授列表', upload_type_str: '教授列表'
        }
      }).then(({ data }) => {
        this.masterDate = data;
      });
    },
  },
  mounted() {
    this.crmId = this.$route.params.crmid;
    this.getStudent();
    this.getScores();
    this.getPayment();
    this.getProcess();
    this.getGiveup();
  },
  mixins: [qcrbPublic],
};
</script>
<style scoped>
  .tab-card-label label{
    display: inline-block;
    width: 120px;
    padding-right: 5px;
    text-align: right;
  }
  .info-manag-wrap{
    margin: 14px;
  }
  .info-manag-wrap .el-row{
    padding: 14px 0;
  }
  .info-manag-wrap .el-row span {
    color: #20a0ff;
  }
  .info-manage-process .el-row span{
    color: #20a0ff;
  }
  .info-manag-textarea {
    border-color: #d1dbe5;
    padding: 14px;
    font-size: 12px;
    border-radius: 4px;
    color: #999595;
  }
  .info-manag-textarea p {
    line-height:26px;
  }
  .info-sales label{
    width: 240px;
  }
  .info-title-pane{
    margin-left: 10px;
    color: #f00;
  }
  .info-title-time{
    display: block;
    color: #ffff00;
    float: right;
    margin-right: 10px;
  }
  .info-manage-process label{
    width: 180px;
  }
  .info-manage-process .el-row{
    padding: 14px 0;
  }
/*  .info-manage-process .info-process-content{
    border: #eee solid 1px;
  }
  .info-manage-process .info-process-content .el-row{
    border-bottom: #eee solid 1px;
  }
  .info-manage-process .info-process-content .el-row:last-child{
    border-bottom: 0;
  }
  .info-manage-process  .info-content-angle{
    border: #e9b4a9 solid 1px;
  }*/
  .info-manage-process .info-process-content{
    position: relative;
    margin: 14px;
    overflow: hidden;
  }
  .info-process-content .info-angle{
    transform: translate3d(-50px, -50px, 0) rotate3d(0, 0, 1, -45deg);
    width: 100px;
    height: 100px;
    position: absolute;
    z-index: 1;
    background: #20a0ff;
    color: #fff;
    text-align: center;
    display: flex;
    align-items: flex-end;
    justify-content:center;
  }
  .special-textarea{
    width: 100%;
    border-right:none;
  }
  .time-default{
    color: #999;
    padding: 0 10px;
  }
  .quill-editor {
    max-height: 400px;
    overflow-y: auto;
  }
  .quill-editor .ql-toolbar{
    height:0;
    padding:0;
    border:none;
    border-bottom: 1px solid #ccc;
  }
</style>
<style>
  .qcrb-blue-span{
    color:#20a0ff
  }
  .qcrb-red-span{
    color:red
  }
</style>
